import {
  forwardRef,
  useCallback,
  useRef,
  type ForwardRefRenderFunction,
  useEffect,
} from "react";
import { CSSTransition } from "react-transition-group";
import { useNavigationHoverContext } from "../contexts/NavigationHoverContext";
import { useSidebarState } from "../state";
import { animationDuration } from "../theme";
import { setForwarderRef } from "../utils/setForwarderRef";
import { StyledPanel } from "./styled";
const NavigationBarPanelNoRef: ForwardRefRenderFunction<HTMLDivElement> = (
  _,
  forwardedRef
) => {
  const { hoveredElementKey, panelRef, setHoveredElementKey } =
    useNavigationHoverContext();
  const state = useSidebarState();

  const transitionRef = useRef<HTMLDivElement>(null);

  const setRef = useCallback(
    (ref: HTMLDivElement) => {
      setForwarderRef(forwardedRef, ref);
      setForwarderRef(transitionRef, ref);
      setForwarderRef(panelRef, ref);
    },
    [forwardedRef, transitionRef, panelRef]
  );

  useEffect(() => {
    if (!state.isCollapsed) {
      setHoveredElementKey(null);
    }
  }, [state.isCollapsed, setHoveredElementKey]);

  return (
    <CSSTransition
      in={state.isCollapsed && !!hoveredElementKey}
      nodeRef={transitionRef}
      timeout={animationDuration.slow}
    >
      <StyledPanel ref={setRef} />
    </CSSTransition>
  );
};
export const NavigationBarPanel = forwardRef<HTMLDivElement>(
  NavigationBarPanelNoRef
);
